import { createReducer, createSelector } from 'redux-starter-kit';
import { putAllInspections, putInspection, putInspections } from './inspectionListActions';


/**
 * A selector for the inspections loaded in the domain state, as a list.
 */
export const selectInspections = createSelector(['via.domain.inspectionList'], map => (map ? Object.values(map) : null));
export const selectAllInspections = createSelector(['via.domain.inspectionListAll'], map => (map ? Object.values(map) : null));

/**
 * A reducer for managing the inspections list in the domain.
 */
const inspectionListReducer = createReducer({}, {
  // Inserts/Updates one inspection
  [putInspection]: (state, action) => {
    const inspectionReason = action.payload;

    return {
      ...state,
      [inspectionReason.reasonCode]: inspectionReason,
    };
  },

  // Inserts/Updates current inspections
  [putInspections]: (state, action) => {
    const inspections = action.payload;
    return inspections.reduce((newState, inspection) => {
      newState[inspection.inspectionCode] = inspection; // eslint-disable-line no-param-reassign
      return newState;
    }, { ...{} });
  },
});

/**
 * A reducer for managing the inspections list in the domain (all inspections unfiltered).
 */
export const inspectionListAllReducer = createReducer({}, {
  // Inserts/Updates all inspections
  [putAllInspections]: (state, action) => {
    const inspections = action.payload;
    return inspections.reduce((newState, inspection) => {
      newState[inspection.inspectionCode] = inspection; // eslint-disable-line no-param-reassign
      return newState;
    }, { ...{} });
  },
});

export default inspectionListReducer;
